export default __webpack_public_path__ + "static/media/go-ahead-and-break-my-heart.4d7530ce.mp3";